import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 24',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(0 -148.4)">
      <g transform="translate(0 148.401)">
        <g>
          <path
            fill={fill}
            d="M12 24a12 12 0 1 1 12-12 12 12 0 0 1-12 12zm0-21.96A9.96 9.96 0 1 0 21.96 12 9.966 9.966 0 0 0 12 2.04z"
          />
        </g>
      </g>
      <g transform="translate(7.128 153.096)">
        <path
          d="M32.074 21.019a1.022 1.022 0 0 0-.272.173c-.322.2-2.846 1.93-.668 7.45L31.7 29.9c2.673 5.3 5.643 4.554 5.99 4.455a1.6 1.6 0 0 0 .322-.1 4.865 4.865 0 0 0 1.411-.619 3.059 3.059 0 0 0-.346-1.609 4.967 4.967 0 0 0-1.088-1.527l-1.51.866c-.767.347-2.5-.965-3.069-2.227l-.569-1.262c-.545-1.262-.371-3.44.4-3.762l1.658-.544s.272-.322-.346-1.708-1.064-1.46-1.064-1.46a5.576 5.576 0 0 0-1.415.616z"
          fill={fill}
          transform="translate(-30.256 -20.4)"
        />
      </g>
    </g>
  </svg>
);
export default SVG;
